import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  GetBoardInvitationsRequestParams,
  GetBoardInvitationsResponse,
} from '../types';

export const getBoardInvitations = async (
  params: GetBoardInvitationsRequestParams,
) => {
  const { path, queryParams } = params;
  const query = stringifyUrlQuery(queryParams);
  const url = `/api/v2/organisations/${path.organisationId}/boards/${path.boardId}/invitations${query}`;
  const response = await apiAuthClient.get<GetBoardInvitationsResponse>(url);
  return response.data;
};
